import {Alert} from "@/components/alert/Alert.tsx";
import {MonitoringServer} from "@/lib/types/monitoring.ts";
import {MetaData, RunTestTaskStatus} from "@/pages/checks/components/form/fields/legacy/testRunnerTypes.tsx";
import {TestRunServerInfo} from "@/pages/checks/components/form/fields/legacy/TestRunServer.tsx";

interface RunTestResultProps {
  result: string;
  testStatus: RunTestTaskStatus;
  testServer?: MonitoringServer;
  meta?: MetaData;
}

export const RunTestResult = ({testStatus, testServer, result, meta}: RunTestResultProps) => {
  if (![RunTestTaskStatus.FAILED, RunTestTaskStatus.COMPLETED].includes(testStatus)) {
    return null;
  }

  return (
    <>
      <TestRunServerInfo testServer={testServer} meta={meta} />
      <Alert
        callout={testStatus === RunTestTaskStatus.COMPLETED ? "Success" : "Error"}
        variant={testStatus === RunTestTaskStatus.COMPLETED ? "verification" : "error"}
        className="mb-0 text-wrap"
      >
        <span style={{whiteSpace: "pre-wrap", overflowWrap: "break-word"}}>{result}</span>
      </Alert>
    </>
  );
};
